import { motion } from "framer-motion";
import { MapPin, Navigation as NavigationIcon } from "lucide-react";
import { useLanguage } from "@/lib/language";

const EASE = [0.16, 1, 0.3, 1];

export const MapSection = () => {
  const { t } = useLanguage();
  return (
    <section
      id="gdzie-nas-znalezc"
      data-testid="map-section"
      className="bg-cream py-20 lg:py-28"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 28, filter: "blur(8px)" }}
          whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 1.1, ease: EASE }}
          className="flex items-center gap-5 border-b border-border-subtle pb-8"
        >
          <MapPin className="text-gold" size={30} strokeWidth={1.5} />
          <h2 className="font-serif font-light text-3xl sm:text-4xl lg:text-5xl text-ink">
            {t.map.title[0]}
            <span className="italic text-gold">{t.map.title[1]}</span>
          </h2>
        </motion.div>

        <div className="grid lg:grid-cols-12 gap-8 lg:gap-16 mt-10 lg:mt-14 items-center">
          <motion.div
            initial={{ opacity: 0, y: 32, filter: "blur(8px)" }}
            whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 1.1, delay: 0.1, ease: EASE }}
            className="lg:col-span-4"
            data-testid="map-address"
          >
            <p className="text-[11px] uppercase tracking-[0.3em] text-gold">
              {t.map.addressLabel}
            </p>
            <p className="mt-5 font-serif text-2xl lg:text-3xl font-light text-ink leading-snug">
              {t.brand.name}
              <br />
              {t.brand.address.street}
              <br />
              {t.brand.address.city}
            </p>
            <div className="h-px w-16 bg-gold/50 my-8" />
            <a
              href={t.map.directionsUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="map-directions-button"
              className="inline-flex items-center gap-3 px-8 py-4 bg-gold text-charcoal text-xs uppercase tracking-[0.2em] font-medium rounded-full hover:bg-goldDark hover:-translate-y-0.5 transition-all duration-300"
            >
              <NavigationIcon size={16} strokeWidth={2} />
              {t.map.directions}
            </a>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 40, scale: 0.98 }}
            whileInView={{ opacity: 1, y: 0, scale: 1 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 1.2, delay: 0.15, ease: EASE }}
            className="lg:col-span-8"
          >
            <div className="rounded-2xl overflow-hidden border border-gold/30 shadow-[0_24px_60px_-24px_rgba(26,24,23,0.25)]">
              <iframe
                title={t.map.mapTitle}
                src="https://www.google.com/maps?q=ul.%20Siedlecka%2082%2C%2008-114%20Sk%C3%B3rzec&z=14&output=embed"
                className="w-full h-[320px] sm:h-[420px] lg:h-[460px] border-0 block"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                data-testid="map-iframe"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default MapSection;
